module.exports = __webpack_public_path__ + "static/media/Eterno Modular Sofa Console_Caramel.387c1a95.png";